exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.aside[data-v-f2850606]{position:fixed;bottom:0;top:50px;padding-top:20px;padding-bottom:20px;width:180px;font-size:.85em;max-height:100vh;z-index:2;-webkit-box-shadow:0 2px 3px hsla(0,0%,4%,.2);box-shadow:0 2px 3px hsla(0,0%,4%,.2);-webkit-transition:width .5s ease;transition:width .5s ease}div.aside.is-collapsed[data-v-f2850606]{width:56px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f2850606","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/VueAside.vue
// module id = 6P3w
// module chunks = 66